import React from 'react';
import styled from 'styled-components';
import Select, { components } from 'react-select';
import SelectArrowImg from '../image/SelectArrowImg';

/**
 * DrowDown Select Button
 */
const SelectDropDownSmallBtnBlock = styled.div`
    height: ${props => props.height || '26px'};
    margin-top: ${props => props.marginTop || '0px'};
    margin-bottom: ${props => props.marginBottom || '0px'};
    margin-left: ${props => props.marginLeft || '0px'};
    margin-right: ${props => props.marginRight || '0px'};
`;


const DropdownIndicator = props => {
    return (
        <components.DropdownIndicator {...props}>
            <SelectArrowImg height='8px' width='12px' />
        </components.DropdownIndicator>
    );
};

const dropdownIndicatorStyles = (base, state) => {
    let changes = {
        // all your override styles
        backgroundColor: 'blue'
    };
    return Object.assign(base, changes);
};


const customStyles = {
    option: (provided, state) => ({
        ...provided,
        padding: 0,
        // marginBottom: 10,
        fontSize: 14,

        color: '#666',
        fontWeight: state.isSelected ? '700' : '',
        backgroundColor: '#ffffff',
        cursor: 'pointer',
        boxShadow: '#ffffff',
    }),

    menu: (provided, state) => ({
        ...provided,
        width: state.selectProps.width,
        //borderBottom: '1px dotted pink',
        border: '1px solid #fcc643',
        fontSize: 14,
        padding: 10,
        // paddingBottom: 10,
        marginTop: 10,
        marginLeft: 40,
        borderRadius: 4,
    }),

    menuList: (provided, state) => ({
        ...provided,
        padding: 0,
    }),

    control: (provied, state) => {
        return {
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            fontSize: 14,
            outline: 'none',
            height: '20px',
            color: 'red',
            //float: 'right',
            padding: 0

        };
    },
    singleValue: (provided, state) => {
        const opacity = state.isDisabled ? 0.5 : 1;
        const transition = 'opacity 300ms';
        const color = '#666';
        const width = state.selectProps.textWidth;
        const textAlign = 'right';
        return { ...provided, opacity, transition, color, textAlign, width };
    },
    indicatorSeparator: (provied, state) => {
        // console.log("provied : " + JSON.stringify(provied));
        return {
            ...provied,
            width: 0
        };
    },

    dropdownIndicator: (provided, state) => ({
        ...provided,
        padding: "0px",
    }),

    valueContainer: (provided, state) => ({
        ...provided,
        padding: 0,
        paddingLeft: 45,
        cursor: 'pointer',
    }),

    indicatorsContainer: (provided, state) => ({
        ...provided,
        //borderBottom: '1px dotted pink',
        padding: "0px",
    }),

}

const SelectDropDownSmallBtn = ({ options, placeholder,
    marginTop, marginBottom, marginLeft, marginRight,
    height, onChange, valueDefault, textWidth }) => {
    return (
        <SelectDropDownSmallBtnBlock
            height={height}
            marginTop={marginTop}
            marginBottom={marginBottom}
            marginLeft={marginLeft}
            marginRight={marginRight}>
            <Select options={options}
                textWidth={textWidth + "px"}
                width={(parseInt(textWidth) + 42)}
                placeholder={placeholder}
                styles={customStyles}
                autosize={false}
                value={valueDefault}
                components={{ DropdownIndicator }}
                isSearchable={false}
                onChange={onChange}
                // menuIsOpen={true}
                theme={theme => ({
                    ...theme,
                    borderRadius: 0,
                    colors: {
                        ...theme.colors,
                        primary25: 'white',
                        primary: 'white',
                        primary50: 'white',
                    },
                })}
            />

        </SelectDropDownSmallBtnBlock>
    );
};

export default SelectDropDownSmallBtn;